import styled from '@emotion/styled';
import { desktopOnly, mobileOnly } from '../../utils/sharedStyles';

export const footerLink = 'footer-link';
export const accordionPanelWrapper = 'accordion-panel-wrapper';
export const accordionDetails = 'accordion-details';

export const StyledAccordionContainer = styled.div`
  @media (${mobileOnly}) {
    width: 100%;
    .${accordionDetails} {
      box-shadow: var(--podium-cds-color-border-tertiary) 0 -1px 0 0 inset;
    }
    .${accordionPanelWrapper} {
      padding: 24px 0;
    }
    .${footerLink} p {
      padding-bottom: 12px;
    }
  }

  @media (${desktopOnly}) {
    display: none;
  }
`;
